import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, ActivationStart, NavigationEnd, ParamMap, Router, RoutesRecognized } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { AccountSandbox } from 'src/core/account/account.sandbox';
import { CommonSandbox } from 'src/core/common/common.sandbox';
import { CategoryModel } from 'src/core/common/models/category.model';
import { USER_ROLES } from 'src/core/helpers/constants.enum';
import { AppSettingService } from 'src/core/services/app.settings';
import { MessageService } from 'src/core/services/messages.service';

@Component({
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    selector: 'app-sidebar'
})
export class SidebarComponent implements OnInit, OnDestroy {
    USER_ROLES = USER_ROLES;

    panelOpenState = false;
    currentShopName: any = null;
    currentUserRole: string = null;
    categories: CategoryModel[] = [];

    private subs: Subscription[] = [];
    catId: number = null;

    constructor(
        private accountSandbox: AccountSandbox,
        private cd: ChangeDetectorRef,
        private appSettings: AppSettingService,
        private commonSandbox: CommonSandbox,
        private message: MessageService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.commonSandbox.doGetCategoryList({});

        this.subs.push(this.accountSandbox.currentUserRole$.subscribe(role => {
            // console.log(role);
            this.currentUserRole = role;
            this.cd.markForCheck();
        }));
        this.subs.push(this.commonSandbox.getCategoryListData$.subscribe(res => {
            if (res) {
                this.categories = res || [];
            }
        }));
        this.subs.push(this.commonSandbox.getCategoryListFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
                this.router.navigate(['404']);
            }
        }))
    }

    navToCat(cat: CategoryModel): void {
        if (!cat.id) {
            return;
        }
        this.catId = cat.id;
        this.router.navigate(['/dashboard/category-posts', { catId: cat.id }]);
    }

    doLout(): void {
        this.accountSandbox.doLogout();
        this.appSettings.setCurrentUser(null);
        this.accountSandbox.doClearGetCurrentUserState();
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}
